import Box from '@elementor/ui/Box';
import Typography from '@elementor/ui/Typography';
import { styled } from '@elementor/ui/styles';
import PropTypes from 'prop-types';
import { __ } from '@utils/i18n';

const ColorContrastPreview = ({ color, backgroundColor }) => {
	return (
		<StyledPreviewContainer color={color} backgroundColor={backgroundColor}>
			<Typography variant="subtitle2" as="span">
				{__('Aa')}
			</Typography>
		</StyledPreviewContainer>
	);
};

const StyledPreviewContainer = styled(Box)`
	width: 40px;
	height: 40px;

	display: flex;
	justify-content: center;
	align-items: center;

	border: 1px solid rgba(12, 13, 14, 0.23);
	border-radius: ${({ theme }) => theme.shape.borderRadius}px;
	background-color: ${({ backgroundColor }) => backgroundColor};
	color: ${({ color }) => color};

	.MuiTypography-root {
		font-size: 24px;
		font-weight: 600;
	}
`;

ColorContrastPreview.propTypes = {
	color: PropTypes.string.isRequired,
	backgroundColor: PropTypes.string.isRequired,
};

export default ColorContrastPreview;
